import { Button, ButtonVariant } from "@src/components/button/Button";
import { CommonModal } from "@src/components/modal/CommonModal";
import { IModalHandle, Modal } from "@src/components/modal/Modal";
import React, { useRef } from "react";
import styles from "./SchedulePrice.module.scss";
import { useAppDispatch, useAppSelector } from "@src/store/hooks";
import { deleteSchedulePrice } from "@src/store/pricing/deleteSchedulePrice";
import { toast } from "sonner";

type TDeleteSchedulePriceModal = {
	ListingIds: Array<number>;
	onSuccess?: () => void;
};

const DeleteSchedulePriceModal = ({ ListingIds, onSuccess }: TDeleteSchedulePriceModal) => {
	const deleteSchedulePriceModal = useRef<IModalHandle>(null);
	const dispatch = useAppDispatch();
	const { loading } = useAppSelector((state) => state.pricing.deleteSchedulePrice);

	const handleDelete = async () => {
		try {
			await dispatch(
				deleteSchedulePrice({
					ListingIds,
				}),
			);
			deleteSchedulePriceModal.current?.closeModal();
			toast.success("Successfully deleted Listing pricing schedule");
			onSuccess?.();
		} catch (error) {
			toast.error(`Failed to delete Listing pricing schedule`);
			console.log(error);
		}
	};

	return (
		<Modal
			style={{ width: 400 }}
			ref={deleteSchedulePriceModal}
			customButton={
				<Button
					type="button"
					onClick={() => deleteSchedulePriceModal.current?.openModal()}
					variant={ButtonVariant.Secondary}
					controlSize="sm">
					Delete
				</Button>
			}>
			<CommonModal
				style={{ padding: 20 }}
				closeModal={() => deleteSchedulePriceModal.current?.closeModal()}
				content={
					<div className={styles.confirmDeleteContainer}>
						<div className={styles.confirmDeleteContainerText}>
							Are you sure you want to remove the listing pricing schedule?
						</div>
						<div className={styles.confirmDeleteContainerButtons}>
							<Button
								disabled={loading}
								type="button"
								onClick={() => deleteSchedulePriceModal.current?.closeModal()}
								variant={ButtonVariant.Secondary}
								controlSize="sm">
								Cancel
							</Button>
							<Button
								disabled={loading}
								isLoading={loading}
								type="button"
								onClick={handleDelete}
								variant={ButtonVariant.Primary}
								controlSize="sm">
								Delete
							</Button>
						</div>
					</div>
				}
				title={"Confirm pricing schedule deletion"}
			/>
		</Modal>
	);
};

export default DeleteSchedulePriceModal;
